export default __webpack_public_path__ + "static/media/google-subscribe-to-calendar.ab51be6b.png";